import React from 'react';
import { useSelector } from 'react-redux';
import AutocompleteMultiselect from '@/components/rhf-mui/AutocompleteMultiselect';
import useStyles from './styles';

const TagMultiselect = () => {
    const classes = useStyles();
    const tags =
        useSelector((state) => state?.user?.activeBusiness?.tags) || [];

    return (
        <AutocompleteMultiselect
            fullWidth
            classes={{
                inputRoot: classes.multiselectInput,
                noOptions: classes.listbox,
                listbox: classes.listbox
            }}
            rhfName="tags"
            options={tags}
            labelIdentifier="name"
            id="tags-multiselect"
            inputLabel="Tags"
            helperText="The maximum number of tags allowed is ten"
            rules={{ validate: (val) => val?.length <= 10 }}
        />
    );
};

export default TagMultiselect;
